import * as React from 'react'
import { RemoveTagButtonConnected } from './RemoveTagButtonConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const RemoveTagButtonExamples = () => {
  return (
    <div className="RemoveTagButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <RemoveTagButtonConnected taskId="123" tagId="123" />
      </Provider>
    </div>
  )
}
